import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
         AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// "YOU HAVE 3 UNSAVED CHILD PARTS — KEEP EDITING OR DISCARD?"
//
// HIS WORDS, 2026-10-15, after losing a phone's worth of work. Closing a form that holds typed work
// now asks, in those words, with the count in it — and the two answers are the two things a person
// actually wants: carry on, or throw it away.
//
// KEEP EDITING IS THE SAFE SIDE and it is the one a stray tap lands on: it is the Cancel button, it
// is what Escape and a tap outside do, and nothing is thrown away without the person saying so.
// Discarding is also honest about what it costs — it says how many.
export function UnsavedWorkDialog({ open, onOpenChange, count, noun = "child part",
                                    onDiscard, testid = "unsaved-work", title, discardLabel }) {
  const many = count === 1 ? "" : "s";
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testid} className="rounded-xl sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">
            {title || `You have ${count} unsaved ${noun}${many}`}
          </AlertDialogTitle>
          <AlertDialogDescription>
            Nothing has been created yet. Keep editing to finish and save {count === 1 ? "it" : "them"},
            or discard to throw {count === 1 ? "it" : "them"} away.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-keep`} className="rounded-lg">Keep editing</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testid}-discard`} onClick={onDiscard}
            className="rounded-lg bg-[#B01E28] hover:bg-[#8E1820] text-white">
            {discardLabel || `Discard ${count} ${noun}${many}`}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
